export const collaborationSetup = {
  junior: {
    workflows: [
      { name: 'UI Design Creation', description: 'Create user interface designs based on UX wireframes and requirements', frequency: 'Daily design work and iterations' },
      { name: 'Design Review Process', description: 'Participate in design critiques and feedback sessions', process: 'Present designs, gather feedback, iterate' },
      { name: 'Developer Handoff', description: 'Collaborate with developers for UI implementation', deliverable: 'Design specifications and assets' }
    ],
    tools: [
      { name: 'Slack', purpose: 'UI design team communication and updates', channels: ['#ui-design', '#design-team', '#frontend-team'] },
      { name: 'Figma', purpose: 'UI design creation and collaboration', access: 'Editor permissions for UI design files' },
      { name: 'Zeplin', purpose: 'Design handoff and developer collaboration', permissions: 'Design upload and specification creation' }
    ],
    processes: [
      { name: 'UI Design Process', steps: ['Receive design brief', 'Create UI concepts', 'Apply visual design', 'Iterate based on feedback', 'Prepare for handoff'] },
      { name: 'Asset Preparation', steps: ['Export design assets', 'Create icon sets', 'Prepare image assets', 'Document design specifications'] }
    ]
  },
  mid: {
    workflows: [
      { name: 'Design System Contribution', description: 'Contribute to and maintain UI component libraries', responsibility: 'Component design and documentation' },
      { name: 'Cross-team UI Coordination', description: 'Coordinate UI design across multiple product areas', scope: 'Multi-team design consistency' },
      { name: 'UI Standards Development', description: 'Develop and maintain UI design standards and guidelines', commitment: 'Design quality and consistency' }
    ],
    tools: [
      { name: 'Abstract', purpose: 'Design version control and team collaboration', access: 'Project lead permissions' },
      { name: 'Principle', purpose: 'UI animation and interaction design', permissions: 'Animation creation and sharing' },
      { name: 'IconJar', purpose: 'Icon library management and organization', access: 'Library creation and management' }
    ],
    processes: [
      { name: 'Component Design Process', steps: ['Analyze component needs', 'Design reusable components', 'Document usage guidelines', 'Maintain component library'] },
      { name: 'UI Quality Assurance', steps: ['Review UI implementations', 'Ensure design consistency', 'Provide feedback to developers', 'Update design standards'] }
    ]
  },
  senior: {
    workflows: [
      { name: 'UI Design Leadership', description: 'Lead UI design vision and strategy across organization', responsibility: 'UI design program leadership and innovation' },
      { name: 'Design System Architecture', description: 'Architect and scale design systems for enterprise use', scope: 'Company-wide UI consistency and efficiency' },
      { name: 'UI Innovation', description: 'Drive innovation in UI design patterns and technologies', impact: 'Design practice advancement and competitive advantage' }
    ],
    tools: [
      { name: 'Design Operations Platform', purpose: 'Enterprise UI design management and optimization', role: 'Platform administrator and strategist' },
      { name: 'Advanced Design System Tools', purpose: 'Enterprise design system governance and automation', access: 'Full system architecture and management' },
      { name: 'UI Analytics Suite', purpose: 'UI performance measurement and optimization', role: 'Analytics strategy and implementation lead' }
    ],
    processes: [
      { name: 'UI Strategy Development', steps: ['Define UI vision', 'Build UI capabilities', 'Measure UI impact', 'Scale UI practices'] },
      { name: 'Design Culture Development', steps: ['Evangelize UI best practices', 'Build design-conscious culture', 'Develop UI talent', 'Drive design excellence'] }
    ]
  }
};
